import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
// Fixa a língua do build (VITE_LOCALE) antes de renderizar — ver src/i18n.js.
import './i18n'
import App from './App.jsx'
import MotionProvider from './components/MotionProvider.jsx'
import './index.css'

// Cada língua é um build estático próprio servido num sub-caminho (/, /en/,
// /uk/, …). O Vite define BASE_URL a partir de `--base=/en/` (ver
// scripts/build-locales.mjs); o router precisa do mesmo prefixo como basename
// para que as rotas internas (/en/direitos, …) e os <Link> funcionem.
// React Router não quer barra final no basename ('' equivale à raiz).
const BASENAME = import.meta.env.BASE_URL.replace(/\/$/, '')

/* O title/description/canonical do index.html são fallback para quem não
   executa JS (crawlers de redes sociais). Como cada rota renderiza os seus (o
   React 19 iça-os para o <head>), ficariam dois de cada — e um crawler lê o
   primeiro, ou seja, o da homepage em todas as páginas. Removem-se aqui,
   antes do primeiro render. */
document.querySelectorAll('head [data-fallback]').forEach((el) => el.remove())

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <MotionProvider>
            <BrowserRouter basename={BASENAME}>
                <App />
            </BrowserRouter>
        </MotionProvider>
    </React.StrictMode>,
)
